import React, {useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import "../CSS/App.css";
import { Container, Row, Col, Button, Form, ButtonGroup } from "react-bootstrap";



import SignupScreen from "../view/SignupScreen";
import LoginScreen from "./LoginScreen";
import ForgotPasswordScreen from "./ForgotPasswordScreen";

import { useGoogleLogin } from '@react-oauth/google';
import { AuthService } from "../Services/AuthService";
import { StorageUtils } from '../Utils/StorageUtils'; // Import the utility
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { DESCRIPTION, ALT_NAME } from "../config/branding.js";
import loginBgImage from '../assets/login_bg.png';

//import jwtDecode from 'jwt-decode';

const LandingPage = () => {
  
  const [showLogin, setShowLogin] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showSignUpScreen, setShowSignUpScreen] = useState(false);
  const [showModal, setShowModal] = useState(false);
      const [active, setActive] = useState("login");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


const navigate = useNavigate();

  // Handle responsive behavior and ensure scrolling is always enabled
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // Always allow scrolling
      document.body.style.overflow = 'auto';
    };
    
    handleResize(); // Set initial state
    window.addEventListener('resize', handleResize);
    
    return () => {
      document.body.style.overflow = 'auto'; // Ensure scrolling is restored
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Function to open the modal
  const handleShowModal = () => {
    console.log("Handle Show Modal Clicked123");
    setShowModal(true);

    if(active === "login") {
      setShowModal(false); 
     setShowLogin(true)
    }
    else {
      setShowLogin(false)
     setShowModal(true); 
    }
  }

  // Function to close the modal
  const handleCloseModal = () => setShowModal(false);
  
  const handleForgotPassword = () => {
    console.log("Forgot Password Clicked123");
    setShowLogin(false); // Hide Signup Modal
    setShowForgotPassword(true); // Show Forgot Password Modal
  };

   const handleSignupScreen = () => {
    console.log("Handle Signup Clicked123");
    setShowLogin(false); // Hide Signup Modal
    setShowForgotPassword(false); // Show Forgot Password Modal
    setShowSignUpScreen(true); // Show Signup Modal
  };

  const handleLoginScreen = () => {
    console.log("Handle Login Clicked123");
    setShowForgotPassword(false); // Show Forgot Password Modal
    setShowSignUpScreen(false); // Show Signup Modal
    setShowModal(false); 
     setShowLogin(true); // Hide Signup Modal
     
    console.log("Handle Login Clicked123");
  };

  
  const login = useGoogleLogin({
    onSuccess: async tokenResponse => {
      console.log('Google Token:', tokenResponse.credential);
      console.log('Google Token1:', tokenResponse.access_token);
      const token = tokenResponse.credential || tokenResponse.access_token;

      try {
              
              const response = await AuthService.googleLogin({
                id_token: token
              });
              console.log('Google Login Response:', response.data);
              // Use comprehensive save that clears cache
              StorageUtils.saveUserDataAndRefresh(response.data);
              console.log('🎆 Google login successful - user data saved with fresh cache:', response.data);
              
              setTimeout(() => {
                window.dispatchEvent(new Event('storage'));
                navigate('/dashboard');
                
                
              }, 1000);
            } catch (error) {
              console.error('Login failed:', error);
              // Handle error, show message to user, etc.
            } finally {
              
            }
      

      // Decode JWT if available
    // try {
    //   const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
    //     headers: {
    //       Authorization: `Bearer ${tokenResponse.access_token}`,
    //     },
    //   });
    //   const userInfo = await res.json();
    //   console.log('Google user info:', userInfo);
    // } catch (err) {
    //   console.error('Failed to fetch user info:', err);
    // }
    },
    onError: () => {
      console.error('Login Failed');
    },
    flow: 'implicit', // or 'auth-code' if using with backend
  });






  // const handleCloseForgotPassword = () => {
  //   setShowForgotPassword(false);
  //   setShowLogin(true); // Optionally, reopen Signup Modal
  // };
// const location = useLocation();
//   const [authType, setAuthType] = useState("");
//       useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
//     const paramValue = queryParams.get("type");
//     setAuthType(paramValue); // Trigger state update when query changes
//   }, [location.search]);




  return (
    <div style={{ 
      minHeight: "100vh", 
      display: "flex", 
      overflow: "auto", 
      height: "auto" 
    }}>
      <Container fluid className="m-0 p-0">
        <Row className="g-0">
          {/* Left Column */}
          <Col
            xs={12}
            md={6}
            className="d-flex flex-column align-items-center p-4 landing-left-col"
            style={{ 
              backgroundColor: "#fff", 
              minHeight: "100vh", 
              justifyContent: "flex-start", 
              paddingTop: "2rem",
              overflowY: "auto"
            }}
          >
            <div className="w-100" style={{ maxWidth: "400px", marginTop: "2rem", padding: "0 0.5rem" }}>
              <h2 className="custom-h2">
                {DESCRIPTION}
              </h2>
              <p className="custom-sub-heading">
                Track and analyze your ChatGPT & Gemini conversations with detailed analytics.
                Join thousands using {ALT_NAME} to understand their AI content's reach.
              </p>
              
              {/* Supported Platforms */}
              <div className="supported-platforms mb-4" style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                gap: '1rem',
                padding: '0.75rem',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef'
              }}>
                <span style={{ fontSize: '0.9rem', color: '#6c757d', fontWeight: '500' }}>Supports:</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <img 
                    src="https://img.icons8.com/color/20/000000/chatgpt.png" 
                    alt="ChatGPT" 
                    style={{ width: '20px', height: '20px' }}
                  />
                  <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>ChatGPT</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <img 
                    src="https://img.icons8.com/color/20/000000/google-logo.png" 
                    alt="Gemini" 
                    style={{ width: '20px', height: '20px' }}
                  />
                  <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>Gemini</span>
                </div>
              </div>

              

              <div className="d-grid gap-3">
                <div className="d-grid my-4">
      <ButtonGroup className="segment-group">
        <Button
          onClick={() => setActive("login")}
          className={`segment-btn ${active === "login" ? "active" : ""}`}
        >
          Login
        </Button>
        <Button
          onClick={() => setActive("signup")}
          className={`segment-btn ${active === "signup" ? "active" : ""}`}
        >
          Sign Up
        </Button>
      </ButtonGroup>
    </div>
                
                <Button
                  variant="outline-dark"
                  className="d-flex align-items-center justify-content-center gap-2"
                  style={{ borderRadius: "50px", fontFamily: "Poppins" }}
                  onClick={() => login()}
                >
                  <img
                    src="https://img.icons8.com/color/24/000000/google-logo.png"
                    alt="Google"
                  />
                  {active === "login" ? "Login with Google" : "Signup with Google"}
                </Button>

                {/* Login Modal */}
                <LoginScreen
                  show={showLogin}
                  handleClose={() => setShowLogin(false)}
                  onForgotPassword={handleForgotPassword} // Pass Forgot Password Handler
                  onSignupClicked={handleSignupScreen} // Pass Signup Handler
                />

                <ForgotPasswordScreen
                  show={showForgotPassword}
                  handleClose={() => setShowForgotPassword(false)}
                />

                <SignupScreen
                  show={showSignUpScreen}
                  handleClose={() => setShowSignUpScreen(false)}
                  onLoginClicked={handleLoginScreen} // Pass Login Handler
                />  


              </div>

              <div className="d-flex align-items-center my-4">
  <hr className="flex-grow-1" />
  <span className="px-3 text-muted">OR</span>
  <hr className="flex-grow-1" />
</div>

              <Form>
                <Button
                  variant="dark"
                  className="w-100"
                  onClick={handleShowModal}
                  style={{ borderRadius: "50px", fontFamily: "Poppins" }}
                >
                  {active === "login" ? "Login with email" : "Signup with email"}
                  
                </Button>
                <SignupScreen show={showModal} handleClose={handleCloseModal} />
              </Form>

              
{active === "login" ? "" : <p className="custom-anchor" >
                By signing up, you agree to the{" "}
                <Link to="/terms-conditions" className="custom-anchor text-decoration-underline">Terms of Service</Link>
                {/* <a href="/terms-conditions" className="custom-anchor text-decoration-underline">
                  Terms of Service
                </a> */}
                {" "}
                and{" "}
                <Link to="/privacy-policy" className="custom-anchor text-decoration-underline">Privacy Policy</Link>
                {/* <a href="/privacy-policy" className="custom-anchor text-decoration-underline">
                  Privacy Policy
                </a> */}
                , including{" "}
                <Link to="/cookie-policy" className="custom-anchor text-decoration-underline">cookie use</Link>
                {/* <a href="/cookie-policy" className="custom-anchor text-decoration-underline">
                  cookie use
                </a> */}
                .
              </p>}
              

            </div>
          </Col>

          {/* Right Column */}
          <Col xs={12} md={6} className="d-none d-md-block">
            <img
              src={loginBgImage}
              alt="Landing"
              className="w-100 h-100 object-fit-cover"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LandingPage;
